import {createElem} from 'common/util/dom';

interface LayoutConfig {
  fullWidth?: boolean;
  bannerContainer?: HTMLElement;
}

const DEFAULT_CONFIG: LayoutConfig = {
  fullWidth: false,
  bannerContainer: null,
};

/**
 * This class acts as a wrapper around methods for changing layout.
 * Certain apps (e.g dashboards) need to override things like max/min width and report-banners
 * based on their layout requirements. Be sure to test any changes in django AND volt mode.
 */
class LayoutManager {
  public setConfig(config: LayoutConfig) {
    /**
     * Set width; our ".width_wrapper" layout div imposes min/max width restrictions.
     * Certain reports can disable this by adding a ".full-width-report" class name.
     */
    const widthWrapper = document.querySelector(`#width_wrapper`);
    if (config.fullWidth) {
      widthWrapper?.classList.add(`full-width-report`);
    } else {
      widthWrapper?.classList.remove(`full-width-report`);
    }

    /**
     * Clear banners if in base template.
     * Previous bannerContainer will have been disconnected at this point
     **/
    const defaultBannerContainer = document.querySelector(`#messages`);
    if (defaultBannerContainer) {
      while (defaultBannerContainer.firstChild) {
        defaultBannerContainer.removeChild(defaultBannerContainer.firstChild);
      }
    }

    const {reportBanners, messageBanner} = this.createBanners();

    /**
     * If custom banner container is provided, use that. Else fallback to default
     * banner container. This gives apps more control over banner placement.
     */
    const bannerContainer = config.bannerContainer || defaultBannerContainer;

    if (bannerContainer) {
      bannerContainer.prepend(messageBanner, reportBanners);
    }

    reportBanners.syncBanners?.();
  }

  /**
   * Reset to default config. Called by spa-nav-manager.ts
   */
  public reset() {
    this.setConfig(DEFAULT_CONFIG);
  }

  private createBanners() {
    return {
      reportBanners: createElem(`mp-report-banners`),
      messageBanner: createElem(`mp-report-message-banner`),
    };
  }
}

export const layoutManager = new LayoutManager();
